/* eslint-disable */
import React from "react";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";

// Animation definition
const animateP = keyframes`
  from {
    --p: 0;
  }
`;

const ScoreGaugeWrapper = styled.div`
  @property --p {
    syntax: "<number>";
    inherits: true;
    initial-value: 0;
  }
  width: 180px;
  height: 100px;
`;

const PieWrapper = styled.div`
  --b: 12px;
  position: relative;
`;

interface PieProps {
  width: number;
  progress: number;
  color: string;
  animate?: boolean;
}

const Pie = styled.div<PieProps>`
  --w: ${(props: PieProps) => props.width}px;
  --p: ${(props: PieProps) => props.progress / 2};
  --c: ${(props: PieProps) => props.color};

  animation: ${(props: PieProps) => (props.animate ? animateP : "none")} 1s 0.5s both;

  position: absolute;

  rotate: -90deg;

  width: var(--w);
  aspect-ratio: 1;

  &:before,
  &:after {
    content: "";
    position: absolute;
    border-radius: 50%;
  }
  &:before {
    inset: 0;
    background:
      radial-gradient(farthest-side, var(--c) 98%, #0000) top/var(--b) var(--b) no-repeat,
      conic-gradient(var(--c) calc(var(--p) * 1%), #0000 0);
    -webkit-mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
    mask: radial-gradient(
      farthest-side,
      #0000 calc(99% - var(--b)),
      #000 calc(100% - var(--b))
    );
  }
  &:after {
    inset: calc(50% - var(--b) / 2);
    background: var(--c);
    transform: rotate(calc(var(--p) * 3.6deg))
      translateY(calc(50% - var(--w) / 2));
  }
`;

interface ScoreProps {
  color: string;
}

const Score = styled.h1<ScoreProps>`
  color: ${(props: ScoreProps) => props.color};

  position: absolute;
  top: 45%;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0;
  text-align: center;
  font-size: 54px;
  line-height: 54px;
`;

interface ScoreGaugeProps {
  source: number | null | string;
  sourceColor: string;
  sourcePieColor: string;
  target?: number | null;
  targetPieColor?: string | null;
}

function ScoreGauge(props: ScoreGaugeProps) {
  const {
    source,
    sourceColor,
    sourcePieColor,
    target = null,
    targetPieColor = null,
  } = props;

  const sourceVal = typeof source === 'number' ? source : Number(source);
  const isValidSource = !isNaN(sourceVal) && source !== null && source !== "";

  return (
    <ScoreGaugeWrapper className="position-relative">
      <PieWrapper>
        <Pie width={180} progress={100} color={"#3A3646"} />
        {(target && targetPieColor && isValidSource && sourceVal <= target) && (
          <Pie width={180} progress={target} color={targetPieColor} animate />
        )}
        {(isValidSource) && (
          <Pie width={180} progress={sourceVal} color={sourcePieColor} animate />
        )}
      </PieWrapper>
      <Score color={sourceColor}>{!isValidSource ? 'N/A' : source}</Score>
    </ScoreGaugeWrapper>
  );
}

export default ScoreGauge;
